import { useEffect } from 'react';

const usePreventBodyScroll = (condition: boolean = true) => {
  useEffect(() => {
    if (!condition) return;

    const isNotHidden = document.body.style.overflowY !== 'hidden';
    if (isNotHidden) {
      document.body.style.overflowY = 'hidden';
    }

    return () => {
      if (isNotHidden) document.body.style.overflowY = 'auto';
    };
  }, [condition]);
};

export default usePreventBodyScroll;
